var r = require("uint8arrays"),
    e = require("@stablelib/sha256"),
    t = require("js-sha3"),
    n = require("elliptic"),
    i = require("@stablelib/ed25519"),
    o = require("@stablelib/xchacha20poly1305"),
    a = require("@stablelib/x25519"),
    u = require("@stablelib/random");

function c(e) {
  return r.toString(e, "base64url");
}

function f(e) {
  var t = e.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
  return r.fromString(t, "base64url");
}

function s(e) {
  return r.fromString(e, "base58btc");
}

function l(e) {
  var t = e.startsWith("0x") ? e.substring(2) : e;
  return r.fromString(t.toLowerCase(), "base16");
}

function h(e) {
  return c(r.fromString(e));
}

function v(e) {
  return r.toString(f(e));
}

function d(e) {
  return r.toString(e, "base16");
}

function p(e) {
  return r.fromString(e);
}

function y(e, t) {
  var n = e.r,
      i = e.s,
      o = e.recoveryParam,
      a = new Uint8Array(t ? 65 : 64);

  if (a.set(r.fromString(n, "base16"), 0), a.set(r.fromString(i, "base16"), 32), t) {
    if (void 0 === o) throw new Error("Signer did not return a recoveryParam");
    a[64] = o;
  }

  return c(a);
}

function g(r) {
  var e = f(r);
  if (e.length < 64 || e.length > 65) throw new TypeError("Wrong size for signature. Expected 64 or 65 bytes, but got " + e.length);
  return {
    r: d(e.slice(0, 32)),
    s: d(e.slice(32, 64)),
    recoveryParam: 65 === e.length ? e[64] : void 0
  };
}

function w(e, t) {
  return r.concat([f(e), f(t)]);
}

var m = /^(0x)?([a-fA-F0-9]{64}|[a-fA-F0-9]{128})$/,
    b = /^([1-9A-HJ-NP-Za-km-z]{44}|[1-9A-HJ-NP-Za-km-z]{88})$/,
    E = /^([0-9a-zA-Z=\-_\+\/]{43}|[0-9a-zA-Z=\-_\+\/]{86})(={0,2})$/;

function P(r) {
  if ("string" == typeof r) {
    if (m.test(r)) return l(r);
    if (b.test(r)) return s(r);
    if (E.test(r)) return f(r);
    throw TypeError("Invalid private key format");
  }

  if (r instanceof Uint8Array) return r;
  throw TypeError("Invalid private key format");
}

function S(r, e) {
  return void 0 === e && (e = 64), r.length === e ? r : "0".repeat(e - r.length) + r;
}

function x(t) {
  var n = "string" == typeof t ? r.fromString(t) : t;
  return e.hash(n);
}

function k(e) {
  var n,
      i = r.fromString(e.slice(2), "base16");
  return "0x" + r.toString((n = i, new Uint8Array(t.keccak_256.arrayBuffer(n))).slice(-20), "base16");
}

function K(e, t) {
  void 0 === t && (t = new Uint8Array(4));
  var n = r.fromString(e.toString(), "base10");
  return t.set(n, 4 - n.length), t;
}

var A = function A(e) {
  return r.concat([K(e.length), e]);
};

function j(t, n, i) {
  if (256 !== n) throw new Error("Unsupported key length: " + n);
  var o = r.concat([A(r.fromString(i)), A(new Uint8Array(0)), A(new Uint8Array(0)), K(n)]);
  return e.hash(r.concat([K(1), t, o]));
}

var J = new n.ec("secp256k1");

function W(r, e) {
  void 0 === e && (e = !1);
  var t = P(r);
  if (32 !== t.length) throw new Error("Invalid private key format. Expecting 32 bytes, but got " + t.length);
  var n = J.keyFromPrivate(t);
  return function (r) {
    try {
      var t = n.sign(x(r)),
          i = t.s,
          o = t.recoveryParam;
      return Promise.resolve(y({
        r: S(t.r.toString("hex")),
        s: S(i.toString("hex")),
        recoveryParam: o
      }, e));
    } catch (r) {
      return Promise.reject(r);
    }
  };
}

function D(r) {
  var e = P(r);
  if (64 !== e.length) throw new Error("Invalid private key format. Expecting 64 bytes, but got " + e.length);
  return function (r) {
    try {
      var t = "string" == typeof r ? p(r) : r,
          n = i.sign(e, t);
      return Promise.resolve(c(n));
    } catch (r) {
      return Promise.reject(r);
    }
  };
}

function T() {
  return (T = Object.assign || function (r) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];

      for (var n in t) {
        Object.prototype.hasOwnProperty.call(t, n) && (r[n] = t[n]);
      }
    }

    return r;
  }).apply(this, arguments);
}

var I = new n.ec("secp256k1");

function C(r, e) {
  void 0 === e && (e = !1);
  var t = f(r);
  if (t.length !== (e ? 65 : 64)) throw new Error("wrong signature length");
  var n = {
    r: d(t.slice(0, 32)),
    s: d(t.slice(32, 64))
  };
  return e && (n.recoveryParam = t[64]), n;
}

function U(r) {
  return r.publicKeyBase58 ? s(r.publicKeyBase58) : r.publicKeyBase64 ? f(r.publicKeyBase64) : r.publicKeyHex ? l(r.publicKeyHex) : new Uint8Array();
}

function O(r, e, t) {
  var n;
  if (e.length > 86) n = [C(e, !0)];else {
    var i = C(e, !1);
    n = [T({}, i, {
      recoveryParam: 0
    }), T({}, i, {
      recoveryParam: 1
    })];
  }
  var o = n.map(function (e) {
    var n = x(r),
        i = I.recoverPubKey(n, e, e.recoveryParam),
        o = i.encode("hex"),
        a = i.encode("hex", !0),
        u = k(o);
    return t.find(function (r) {
      var e = r.publicKeyHex;
      return e === o || e === a || r.ethereumAddress === u;
    });
  }).filter(function (r) {
    return null != r;
  });
  if (0 === o.length) throw new Error("Signature invalid for JWT");
  return o[0];
}

function B(r, e, t) {
  var n = p(r),
      o = f(e),
      a = t.find(function (r) {
    return i.verify(U(r), n, o);
  });
  if (!a) throw new Error("Signature invalid for JWT");
  return a;
}

var N = {
  ES256K: function ES256K(r, e, t) {
    var n = x(r),
        i = C(e),
        o = t.filter(function (r) {
      return void 0 === r.ethereumAddress;
    }),
        a = t.filter(function (r) {
      return void 0 !== r.ethereumAddress;
    }),
        u = o.find(function (r) {
      try {
        var e = U(r);
        return I.keyFromPublic(e).verify(n, i);
      } catch (r) {
        return !1;
      }
    });
    if (!u && a.length > 0 && (u = O(r, e, a)), !u) throw new Error("Signature invalid for JWT");
    return u;
  },
  "ES256K-R": O,
  Ed25519: B,
  EdDSA: B
};

function X(r) {
  var e = N[r];
  if (!e) throw new Error("Unsupported algorithm " + r);
  return e;
}

function V(r) {
  return "object" == typeof r && "r" in r && "s" in r;
}

function _(r) {
  return function (e, t) {
    try {
      return Promise.resolve(t(e)).then(function (e) {
        if (V(e)) return y(e, r);
        if (r && void 0 === g(e).recoveryParam) throw new Error("ES256K-R not supported when signer doesn't provide a recovery param");
        return e;
      });
    } catch (r) {
      return Promise.reject(r);
    }
  };
}

function q() {
  return function (r, e) {
    try {
      return Promise.resolve(e(r)).then(function (r) {
        if (V(r)) throw new Error("expected a signer function that returns a string instead of signature object");
        return r;
      });
    } catch (r) {
      return Promise.reject(r);
    }
  };
}

X.toSignatureObject = C;

var H = {
  ES256K: _(),
  "ES256K-R": _(!0),
  Ed25519: q(),
  EdDSA: q()
},
    z = function z(r, e, t) {
  void 0 === t && (t = {});

  try {
    t.alg || (t.alg = F);

    var n = "string" == typeof r ? r : L(r),
        i = [L(t), n].join("."),
        o = function (r) {
      var e = H[r];
      if (!e) throw new Error("Unsupported algorithm " + r);
      return e;
    }(t.alg);

    return Promise.resolve(o(i, e)).then(function (r) {
      return [i, r].join(".");
    });
  } catch (r) {
    return Promise.reject(r);
  }
},
    Z = {
  ES256K: ["Secp256k1VerificationKey2018", "Secp256k1SignatureVerificationKey2018", "EcdsaPublicKeySecp256k1", "EcdsaSecp256k1VerificationKey2019"],
  "ES256K-R": ["Secp256k1VerificationKey2018", "Secp256k1SignatureVerificationKey2018", "EcdsaPublicKeySecp256k1", "EcdsaSecp256k1VerificationKey2019"],
  Ed25519: ["ED25519SignatureVerification", "Ed25519VerificationKey2018"],
  EdDSA: ["ED25519SignatureVerification", "Ed25519VerificationKey2018"]
},
    F = "ES256K";

function L(r) {
  return h(JSON.stringify(r));
}

function R(r) {
  var e = r.match(/^([a-zA-Z0-9_-]+)\.([a-zA-Z0-9_-]+)\.([a-zA-Z0-9_-]+)$/);
  if (e) return {
    header: JSON.parse(v(e[1])),
    payload: e[2],
    signature: e[3],
    data: e[1] + "." + e[2]
  };
  throw new Error("Incorrect format JWS");
}

function $(r) {
  if (!r) throw new Error("no JWT passed into decodeJWT");

  try {
    var e = R(r);
    return Object.assign(e, {
      payload: JSON.parse(v(e.payload))
    });
  } catch (r) {
    throw new Error("Incorrect format JWT");
  }
}

function M(r, e) {
  var t = r.header,
      n = r.data,
      i = r.signature;
  return Array.isArray(e) || (e = [e]), X(t.alg)(n, i, e);
}

var G = "undefined" != typeof Symbol ? Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator")) : "@@iterator";

function Q(r, e, t) {
  if (!r.s) {
    if (t instanceof Y) {
      if (!t.s) return void (t.o = Q.bind(null, r, e));
      1 & e && (e = t.s), t = t.v;
    }

    if (t && t.then) return void t.then(Q.bind(null, r, e), Q.bind(null, r, 2));
    r.s = e, r.v = t;
    var n = r.o;
    n && n(r);
  }
}

var Y = function () {
  function r() {}

  return r.prototype.then = function (e, t) {
    var n = new r(),
        i = this.s;

    if (i) {
      var o = 1 & i ? e : t;

      if (o) {
        try {
          Q(n, 1, o(this.v));
        } catch (r) {
          Q(n, 2, r);
        }

        return n;
      }

      return this;
    }

    return this.o = function (r) {
      try {
        var i = r.v;
        1 & r.s ? Q(n, 1, e ? e(i) : i) : t ? Q(n, 1, t(i)) : Q(n, 2, i);
      } catch (r) {
        Q(n, 2, r);
      }
    }, n;
  }, r;
}();

function rr(r) {
  return r instanceof Y && 1 & r.s;
}

function er(r, e) {
  var t = r.ciphertext,
      n = r.tag,
      i = r.recipient,
      o = {
    protected: r.protectedHeader,
    iv: c(r.iv),
    ciphertext: c(t),
    tag: c(n)
  };
  return e && (o.aad = c(e)), i && (o.recipients = [i]), o;
}

function tr(r) {
  var e = new o.XChaCha20Poly1305(r);
  return function (r, t) {
    var n = u.randomBytes(e.nonceLength),
        i = e.seal(n, r, t);
    return {
      ciphertext: i.subarray(0, i.length - e.tagLength),
      tag: i.subarray(i.length - e.tagLength),
      iv: n
    };
  };
}

function nr(r) {
  var e = tr(r),
      t = "XC20P";
  return {
    alg: "dir",
    enc: t,
    encrypt: function encrypt(r, n, i) {
      void 0 === n && (n = {});

      try {
        var o = h(JSON.stringify(Object.assign({
          alg: "dir"
        }, n, {
          enc: t
        }))),
            a = new Uint8Array(Buffer.from(i ? o + "." + c(i) : o));
        return Promise.resolve(T({}, e(r, a), {
          protectedHeader: o
        }));
      } catch (r) {
        return Promise.reject(r);
      }
    }
  };
}

function ir(r) {
  var e = new o.XChaCha20Poly1305(r);
  return {
    alg: "dir",
    enc: "XC20P",
    decrypt: function decrypt(r, t, n) {
      try {
        return Promise.resolve(e.open(t, r, n));
      } catch (r) {
        return Promise.reject(r);
      }
    }
  };
}

function or(r, e) {
  var t = function t(_t) {
    try {
      var u = a.generateKeyPair(),
          f = tr(j(a.sharedKey(u.secretKey, r), i, n))(_t),
          s = {
        encrypted_key: c(f.ciphertext),
        header: {
          alg: n,
          iv: c(f.iv),
          tag: c(f.tag),
          epk: {
            kty: "OKP",
            crv: o,
            x: c(u.publicKey)
          }
        }
      };
      return e && (s.header.kid = e), Promise.resolve(s);
    } catch (r) {
      return Promise.reject(r);
    }
  },
      n = "ECDH-ES+XC20PKW",
      i = 256,
      o = "X25519";

  return {
    alg: n,
    enc: "XC20P",
    encrypt: function encrypt(r, e, n) {
      void 0 === e && (e = {});

      try {
        Object.assign(e, {
          alg: void 0
        });
        var i = u.randomBytes(32);
        return Promise.resolve(nr(i).encrypt(r, e, n)).then(function (r) {
          return Promise.resolve(t(i)).then(function (e) {
            return T({}, r, {
              recipient: e,
              cek: i
            });
          });
        });
      } catch (r) {
        return Promise.reject(r);
      }
    },
    encryptCek: t
  };
}

exports.ES256KSigner = W, exports.EdDSASigner = D, exports.EllipticSigner = function (r) {
  return W(r);
}, exports.NaclSigner = function (r) {
  return D(r);
}, exports.SimpleSigner = function (r) {
  var e = W(r, !0);
  return function (r) {
    try {
      return Promise.resolve(e(r)).then(g);
    } catch (r) {
      return Promise.reject(r);
    }
  };
}, exports.createJWE = function (r, e, t, n) {
  void 0 === t && (t = {});

  try {
    if ("dir" === e[0].alg) {
      if (e.length > 1) throw new Error('Can only do "dir" encryption to one key.');
      return Promise.resolve(e[0].encrypt(r, t, n)).then(function (r) {
        return er(r, n);
      });
    }

    var i,
        o,
        a = e[0].enc;
    if (!e.reduce(function (r, e) {
      return r && e.enc === a;
    }, !0)) throw new Error("Incompatible encrypters passed");

    var u = function (r, e, t) {
      if ("function" == typeof r[G]) {
        var n,
            i,
            o,
            a = r[G]();

        if (function r(t) {
          try {
            for (; !(n = a.next()).done;) {
              if ((t = e(n.value)) && t.then) {
                if (!rr(t)) return void t.then(r, o || (o = Q.bind(null, i = new Y(), 2)));
                t = t.v;
              }
            }

            i ? Q(i, 1, t) : i = t;
          } catch (r) {
            Q(i || (i = new Y()), 2, r);
          }
        }(), a.return) {
          var u = function u(r) {
            try {
              n.done || a.return();
            } catch (r) {}

            return r;
          };

          if (i && i.then) return i.then(u, function (r) {
            throw u(r);
          });
          u();
        }

        return i;
      }

      if (!("length" in r)) throw new TypeError("Object is not iterable");

      for (var c = [], f = 0; f < r.length; f++) {
        c.push(r[f]);
      }

      return function (r, e, t) {
        var n,
            i,
            o = -1;
        return function t(a) {
          try {
            for (; ++o < r.length;) {
              if ((a = e(o)) && a.then) {
                if (!rr(a)) return void a.then(t, i || (i = Q.bind(null, n = new Y(), 2)));
                a = a.v;
              }
            }

            n ? Q(n, 1, a) : n = a;
          } catch (r) {
            Q(n || (n = new Y()), 2, r);
          }
        }(), n;
      }(c, function (r) {
        return e(c[r]);
      });
    }(e, function (e) {
      var a = function () {
        if (i) {
          var a = o.recipients,
              u = a.push;
          return Promise.resolve(e.encryptCek(i)).then(function (r) {
            u.call(a, r);
          });
        }

        return Promise.resolve(e.encrypt(r, t, n)).then(function (r) {
          i = r.cek, o = er(r, n);
        });
      }();

      if (a && a.then) return a.then(function () {});
    });

    return Promise.resolve(u && u.then ? u.then(function () {
      return o;
    }) : o);
  } catch (r) {
    return Promise.reject(r);
  }
}, exports.createJWS = z, exports.createJWT = function (r, e, t) {
  var n = e.issuer,
      i = e.signer,
      o = e.alg,
      a = e.expiresIn;
  void 0 === t && (t = {});

  try {
    if (!i) throw new Error("No Signer functionality has been configured");
    if (!n) throw new Error("No issuing DID has been configured");
    t.typ || (t.typ = "JWT"), t.alg || (t.alg = o);
    var u = {
      iat: Math.floor(Date.now() / 1e3),
      exp: void 0
    };

    if (a) {
      if ("number" != typeof a) throw new Error("JWT expiresIn is not a number");
      u.exp = (r.nbf || u.iat) + Math.floor(a);
    }

    var c = T({}, u, r, {
      iss: n
    });
    return z(c, i, t);
  } catch (r) {
    return Promise.reject(r);
  }
}, exports.decodeJWT = $, exports.decryptJWE = function (r, e) {
  try {
    var t = function t(r) {
      if (null === a) throw new Error("Failed to decrypt");
      return a;
    };

    !function (r) {
      if (!(r.protected && r.iv && r.ciphertext && r.tag)) throw new Error("Invalid JWE");
      r.recipients && r.recipients.map(function (r) {
        if (!r.header || !r.encrypted_key) throw new Error("Invalid JWE");
      });
    }(r);
    var n = JSON.parse(v(r.protected));
    if (n.enc !== e.enc) throw new Error("Decrypter does not support: '" + n.enc + "'");
    var i = w(r.ciphertext, r.tag),
        o = new Uint8Array(Buffer.from(r.aad ? r.protected + "." + r.aad : r.protected)),
        a = null,
        u = "dir" === n.alg && "dir" === e.alg ? Promise.resolve(e.decrypt(i, f(r.iv), o)).then(function (r) {
      a = r;
    }) : function () {
      if (r.recipients && 0 !== r.recipients.length) {
        var t = 0;
        return function (r, e, t) {
          for (var n;;) {
            var i = r();
            if (rr(i) && (i = i.v), !i) return o;

            if (i.then) {
              n = 0;
              break;
            }

            var o = t();

            if (o && o.then) {
              if (!rr(o)) {
                n = 1;
                break;
              }

              o = o.s;
            }

            if (e) {
              var a = e();

              if (a && a.then && !rr(a)) {
                n = 2;
                break;
              }
            }
          }

          var u = new Y(),
              c = Q.bind(null, u, 2);
          return (0 === n ? i.then(s) : 1 === n ? o.then(f) : a.then(l)).then(void 0, c), u;

          function f(n) {
            o = n;

            do {
              if (e && (a = e()) && a.then && !rr(a)) return void a.then(l).then(void 0, c);
              if (!(i = r()) || rr(i) && !i.v) return void Q(u, 1, o);
              if (i.then) return void i.then(s).then(void 0, c);
              rr(o = t()) && (o = o.v);
            } while (!o || !o.then);

            o.then(f).then(void 0, c);
          }

          function s(r) {
            r ? (o = t()) && o.then ? o.then(f).then(void 0, c) : f(o) : Q(u, 1, o);
          }

          function l() {
            (i = r()) ? i.then ? i.then(s).then(void 0, c) : s(i) : Q(u, 1, o);
          }
        }(function () {
          return !a && t < r.recipients.length;
        }, function () {
          return t++;
        }, function () {
          var u = r.recipients[t];
          Object.assign(u.header, n);

          var c = function () {
            if (u.header.alg === e.alg) return Promise.resolve(e.decrypt(i, f(r.iv), o, u)).then(function (r) {
              a = r;
            });
          }();

          if (c && c.then) return c.then(function () {});
        });
      }

      throw new Error("Invalid JWE");
    }();
    return Promise.resolve(u && u.then ? u.then(t) : t());
  } catch (r) {
    return Promise.reject(r);
  }
}, exports.resolveX25519Encrypters = function (r, e) {
  try {
    return Promise.all(r.map(function (r) {
      try {
        return Promise.resolve(e.resolve(r)).then(function (e) {
          var t;
          if (!e.keyAgreement) throw new Error("Could not find x25519 key for " + r);
          var n = (null == (t = e.keyAgreement) ? void 0 : t.map(function (r) {
            return "string" == typeof r ? e.publicKey.find(function (e) {
              return e.id === r;
            }) : r;
          })).find(function (r) {
            return "X25519KeyAgreementKey2019" === r.type && Boolean(r.publicKeyBase58);
          });
          if (!n) throw new Error("Could not find x25519 key for " + r);
          return or(s(n.publicKeyBase58), n.id);
        });
      } catch (r) {
        return Promise.reject(r);
      }
    }));
  } catch (r) {
    return Promise.reject(r);
  }
}, exports.toEthereumAddress = k, exports.verifyJWS = function (r, e) {
  return M(R(r), e);
}, exports.verifyJWT = function (r, e) {
  void 0 === e && (e = {
    resolver: null,
    auth: null,
    audience: null,
    callbackUrl: null,
    skewTime: null
  });

  try {
    if (!e.resolver) throw new Error("No DID resolver has been configured");
    var t = $(r),
        n = t.payload,
        i = t.header,
        o = t.signature,
        a = t.data;
    return Promise.resolve(function (r, e, t, n) {
      try {
        var i = Z[e];
        if (!i || 0 === i.length) throw new Error("No supported signature types for algorithm " + e);
        return Promise.resolve(r.resolve(t)).then(function (r) {
          if (!r) throw new Error("Unable to resolve DID document for " + t);

          var o = function o(r, e) {
            var t = r.publicKey.filter(function (r) {
              return e === r.id;
            });
            return t.length > 0 ? t[0] : null;
          },
              a = r.publicKey || [];

          n && (a = (r.authentication || []).map(function (e) {
            return "string" == typeof e ? o(r, e) : "string" == typeof e.publicKey ? o(r, e.publicKey) : e;
          }).filter(function (r) {
            return null != r;
          }));
          var u = a.filter(function (r) {
            var e = r.type;
            return i.find(function (r) {
              return r === e;
            });
          });
          if (n && (!u || 0 === u.length)) throw new Error("DID document for " + t + " does not have public keys suitable for authenticating user");
          if (!u || 0 === u.length) throw new Error("DID document for " + t + " does not have public keys for " + e);
          return {
            authenticators: u,
            issuer: t,
            doc: r
          };
        });
      } catch (r) {
        return Promise.reject(r);
      }
    }(e.resolver, i.alg, n.iss, e.auth)).then(function (t) {
      var u = t.doc,
          c = t.issuer;
      return Promise.resolve(M({
        header: i,
        data: a,
        signature: o
      }, t.authenticators)).then(function (t) {
        var i = Math.floor(Date.now() / 1e3),
            o = e.skewTime >= 0 ? e.skewTime : 300;

        if (t) {
          var a = i + o;

          if (n.nbf) {
            if (n.nbf > a) throw new Error("JWT not valid before nbf: " + n.nbf);
          } else if (n.iat && n.iat > a) throw new Error("JWT not valid yet (issued in the future) iat: " + n.iat);

          if (n.exp && n.exp <= i - o) throw new Error("JWT has expired: exp: " + n.exp + " < now: " + i);

          if (n.aud) {
            if (!e.audience && !e.callbackUrl) throw new Error("JWT audience is required but your app address has not been configured");
            if (void 0 === (Array.isArray(n.aud) ? n.aud : [n.aud]).find(function (r) {
              return e.audience === r || e.callbackUrl === r;
            })) throw new Error("JWT audience does not match your DID or callback url");
          }

          return {
            payload: n,
            doc: u,
            issuer: c,
            signer: t,
            jwt: r
          };
        }
      });
    });
  } catch (r) {
    return Promise.reject(r);
  }
}, exports.x25519Decrypter = function (r) {
  var e = "ECDH-ES+XC20PKW";
  return {
    alg: e,
    enc: "XC20P",
    decrypt: function decrypt(t, n, i, o) {
      try {
        if (function (r) {
          if (!(r.epk && r.iv && r.tag)) throw new Error("Invalid JWE");
        }(o.header), "X25519" !== o.header.epk.crv) return Promise.resolve(null);
        var u = f(o.header.epk.x),
            c = j(a.sharedKey(r, u), 256, e),
            s = w(o.encrypted_key, o.header.tag);
        return Promise.resolve(ir(c).decrypt(s, f(o.header.iv))).then(function (r) {
          return null === r ? null : ir(r).decrypt(t, n, i);
        });
      } catch (r) {
        return Promise.reject(r);
      }
    }
  };
}, exports.x25519Encrypter = or, exports.xc20pDirDecrypter = ir, exports.xc20pDirEncrypter = nr;